<template>
  <div class="page rank">
    <div class="top">
      <div>
        <div class="icon"></div>
        <div class="title"><span>Ranking</span></div>
        <div class="actions">
          <div class="select">
            <span>{{ type }}&nbsp;<i class="fa-solid fa-angle-down"></i></span>
            <div class="boxSelect">
              <div class="option" @click="() => {getRank(20, 'comments'); type = 'Comentários'}">Comentários</div>
              <div class="option" @click="() => {getRank(20, 'locs'); type = 'Locutores'}">Locutores</div>
              <div class="option" @click="() => {getRank(20, 'prom'); type = 'Promotores'}">Promotores</div>
              <div class="option" @click="() => {getRank(20, 'mark'); type = 'Marketing'}">Marketing</div>
              <div class="option" @click="() => {getRank(20, 'prog'); type = 'Programadores'}">Programadores</div>
              <div class="option" @click="() => {getRank(20, 'const'); type = 'Construtores'}">Construtores</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="ranking">
        <div class="box rank2" v-for="(r, index) in rank2" :key="index">
          <ItemTip :title="r.user+'<br>'+r.count" top="-85%" line="24px" />
          <div class="avatar" @click="() => {showP = true; perfilName = r.user}"
               :style="{backgroundImage: `url('${avatarUrl(r.user, { headonly: 0 })}')`}"></div>
        </div>
        <div class="box rank1" v-for="(r, index) in rank1" :key="index">
          <ItemTip :title="r.user+'<br>'+r.count" top="-85%" line="24px" />
          <div class="avatar" @click="() => {showP = true; perfilName = r.user}"
               :style="{backgroundImage: `url('${avatarUrl(r.user, { head_direction: 3, headonly: 0 })}')`}"></div>
        </div>
        <div class="box rank3" v-for="(r, index) in rank3" :key="index">
          <ItemTip :title="r.user+'<br>'+r.count" top="-85%" line="24px" />
          <div class="avatar" @click="() => {showP = true; perfilName = r.user}"
               :style="{backgroundImage: `url('${avatarUrl(r.user, { action: 'std,crr=', direction: 4, head_direction: 3, img_format: '', dance: '', effect: '', frame_num: 30 })}')`}"></div>
        </div>
      </div>
      <div class="rankplus">
        <div class="boxplus" v-for="(r, index) in rankplus" :key="index">
          <div class="left" @click="() => {showP = true; perfilName = r.user}">
            <div class="avatar"
                 :style="{backgroundImage: `url('${avatarUrl(r.user, { headonly: 0 })}')`}"></div>
            <div class="nick">{{ r.user }}</div>
          </div>
          <div class="number">{{ r.rank }}º</div>
        </div>
      </div>
    </div>
    <Transition name="slide-fade">
      <ItemPerfil v-if="showP" @close="showP = false" :user="perfilName" />
    </Transition>
  </div>
</template>

<script setup>

import { getRank as apiGetRank, avatarUrl } from '@/services/api.js'
import ItemTip from '@/components/usefulness/tooltip.vue'
import ItemPerfil from '@/components/modals/perfil.vue'
import { ref } from 'vue'

const rank1 = ref([])
const rank2 = ref([])
const rank3 = ref([])
const rankplus = ref([])
const type = ref('Comentários')
const showP = ref(false)
const perfilName = ref('')

async function getRank(limit, rankType = '') {
  const data = await apiGetRank(limit, rankType)
  rank1.value    = data.rankTop?.[0] ?? []
  rank2.value    = data.rankTop?.[1] ?? []
  rank3.value    = data.rankTop?.[2] ?? []
  rankplus.value = data.rankPlus ?? []
}

getRank(20)

</script>

<style scoped>
.rank .top .icon {
  background-color: #21415C;
  background-position: 5px -66px;
}

.rank .top .select {
  float: right;
  width: 120px;
  height: 34px;
  border-radius: 12px;
  color: #112535;
  font-size: 14px;
}

.rank .top .select span {
  width: 100%;
  height: 100%;
  float: left;
  line-height: 34px;
  text-align: center;
  background-color: #D7E0E9;
  border-radius: 12px;
}

.rank .top .select .boxSelect {
  position: relative;
  float: left;
  width: 100%;
  height: auto;
  background-color: #C8D2DC;
  border-radius: 12px;
  opacity: 0;
  visibility: hidden;
  transition: all .3s ease .1s;
  z-index: 99;
}

.rank .top .select:hover .boxSelect {
  opacity: 1;
  visibility: visible;
}

.rank .top .select .boxSelect div {
  float: left;
  width: 100%;
  height: 32px;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  cursor: pointer;
}

.rank .top .select .boxSelect div:hover {
  font-weight: 600;
}

.rank .content {
  padding: 0;
}

.rank .content .ranking {
  position: relative;
  float: left;
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  height: 240px;
  background-color: #E6EBF1;
  border-radius: 12px 12px 0 0;
}

.rank .content .ranking .box {
  position: relative;
  float: left;
  height: 133px;
  width: 66px;
  background-repeat: no-repeat;
}

.rank .content .ranking .box.rank2 {
  background-image: url('../assets/rank_2.png');
  margin-top: 145px;
}

.rank .content .ranking .box.rank1 {
  background-image: url('../assets/rank_1.png');
  margin-top: 107px;
}

.rank .content .ranking .box.rank3 {
  background-image: url('../assets/rank_3.png');
  margin-top: 157px;
}

.rank .content .box .avatar {
  float: left;
  width: 100%;
  height: 130px;
  margin: -96px 0 0 -2px;
  background-repeat: no-repeat;
  background-position: center;
}

.rank .content .rankplus {
  float: left;
  width: 100%;
  padding: 10px;
  height: auto;
}

.rank .content .rankplus .boxplus {
  float: left;
  width: 100%;
  height: auto;
  border-radius: 12px;
  margin-bottom: 10px;
  background-color: #D7E0E9;
  padding: 15px 0;
}

.rank .content .rankplus .boxplus:last-of-type {
  margin: 0;
}

.rank .content .rankplus .boxplus .left {
  float: left;
  width: 240px;
  height: 40px;
  border-radius: 0 12px 12px 0;
  background-color: #75879A;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  line-height: 40px;
  text-align: right;
  padding-right: 20px;
}

.rank .content .rankplus .boxplus .avatar {
  float: left;
  width: 56px;
  height: 84px;
  background-repeat: no-repeat;
  background-position: center;
  margin: -29px 0 0 14px;
}

.rank .content .rankplus .boxplus .number {
  float: right;
  width: 50px;
  height: 40px;
  border-radius: 12px 0 0 12px;
  background-color: #75879A;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  text-align: center;
  line-height: 40px;
}
</style>
